import { call, put, takeEvery } from "redux-saga/effects"

import {
  CALLS_GET_ADMIN_DASHBOARD_DATA,
  CLICKS_GET_ADMIN_DASHBOARD_DATA,
  SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA,
  QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA,
  GET_ADMIN_ANALYTICS_DATA,
  GET_ADMIN_ANALYTICS_PIXEL_STATS,
  LEADS_GET_ADMIN_DASHBOARD_DATA,
  GET_ADMIN_USER_SMART_VIEWS,
  UPDATE_ADMIN_USER_SMART_VIEW,
  CREATE_ADMIN_USER_SMART_VIEW,
  GET_ADMIN_ANALYTICS_COMPARE_TO_DATA,
  GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS,
  QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA,
  GET_REVAMPED_ADMIN_ANALYTICS_DATA,
  GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA,
  GET_ADMIN_DASHBOARD_REVAMP_DATA,
  GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP,
  GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP
} from "./actionTypes"

import {
  getCallsAdminDashboardDataError,
  getCallsAdminDashboardDataSuccess,
  getAdminAnalyticsDataSuccess,
  getAdminAnalyticsDataError,
  getLeadsAdminDashboardDataError,
  getLeadsAdminDashboardDataSuccess,
  getClicksAdminDashboardDataSuccess,
  getClicksAdminDashboardDataError,
  getAdminAnalyticsPixelStatsSuccess,
  getAdminAnalyticsPixelStatsError,
  getSyndiClicksAdminDashboardDataSuccess,
  getSyndiClicksAdminDashboardDataError,
  getQuoteFunnelsAdminDashboardDataSuccess,
  getQuoteFunnelsAdminDashboardDataError,
  getAdminUserSmartViewsSuccess,
  getAdminUserSmartViewsError,
  createAdminUserSmartViewsSuccess,
  createAdminUserSmartViewsError,
  updateAdminUserSmartViewsSuccess,
  updateAdminUserSmartViewsError,
  getAdminAnalyticsCompareToDataSuccess,
  getAdminAnalyticsCompareToDataError,
  getAdminAnalyticsPixelCompareToStatsSuccess,
  getAdminAnalyticsPixelCompareToStatsError,
  getQuoteFunnelsLeadsCallsAdminDashboardDataSuccess,
  getQuoteFunnelsLeadsCallsAdminDashboardDataError,
  getRevampedAdminAnalyticsCompareToDataSuccess,
  getRevampedAdminAnalyticsDataSuccess,
  getRevampedAdminAnalyticsDataError,
  getRevampedAdminAnalyticsCompareToDataError,
  getAdminDashboardRevampDataSuccess,
  getAdminDashboardRevampDataError,
  getAdminDashboardDateRangeRevampSuccess,
  getAdminDashboardDateRangeRevampError,
  getAdminDashboardCompareToRevampSuccess,
  getAdminDashboardCompareToRevampError
} from "./actions"

import {
  genericGetRequest,
  genericPostRequest,
  genericPutRequest
} from "../../../helpers/sf_backend_helper"
import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { NAME_OF_PRODUCT_TYPES } from "helpers/sf_constants"

// function* onGetDashboardData(payload) {
//   try {
//     let user_auth = localStorage.getItem("authUser")
//     const response = yield call(
//       SfPostRequest,
//       `${AppConfiguration.BACKEND_URL}/api/v1/dashboards`,
//       {
//         token: JSON.parse(user_auth).user.token,
//         account_id: JSON.parse(user_auth).user.account_id,
//         payload: payload
//       }
//     )

//     yield put(getDashboardDataSuccess(response, payload.api_type))
//   } catch (error) {
//     yield put(getDashboardDataError(error, payload.api_type))
//   }
// }

function* onGetAdminDashboardDataClicks(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const ver = action.api_ver
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/${ver}/admin_dashboard/clicks/${action.api_type.replace("clicks_", '')}`,
      {
        body: JSON.stringify({
          ...action.payload.api_data,
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": user.token
        }
      })
    yield put(getClicksAdminDashboardDataSuccess(response, action.api_type))
  } catch (error) {
    yield put(getClicksAdminDashboardDataError(error, action.api_type))
  }
}

function* onGetAdminDashboardDataSyndiClicks(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const ver = 'v2'
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/${ver}/admin_dashboard/syndi_clicks/${action.api_type.replace("syndi_clicks_", '')}`,
      {
        body: JSON.stringify({
          ...action.payload.api_data,
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": user.token
        }
      })
    yield put(getSyndiClicksAdminDashboardDataSuccess(response, action.api_type))
  } catch (error) {
    yield put(getSyndiClicksAdminDashboardDataError(error, action.api_type))
  }
}

function* onGetAdminDashboardDataQuoteFunnels(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const ver = 'v2'
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/${ver}/admin_dashboard/quote_funnels/${action.api_type.replace("quote_funnels_", '')}`,
      {
        body: JSON.stringify({
          ...action.payload.api_data,
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": user.token
        }
      })
    yield put(getQuoteFunnelsAdminDashboardDataSuccess(response, action.api_type))
  } catch (error) {
    yield put(getQuoteFunnelsAdminDashboardDataError(error, action.api_type))
  }
}

function* onGetAdminDashboardDataQuoteFunnelsLeadsCalls(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const ver = 'v2'
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/${ver}/admin_dashboard/quote_funnels/${action.api_type.replace("quote_funnels_", '')}`,
      {
        body: JSON.stringify({
          ...action.payload.api_data,
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": user.token
        }
      })
    yield put(getQuoteFunnelsLeadsCallsAdminDashboardDataSuccess(response, action.api_type))
  } catch (error) {
    yield put(getQuoteFunnelsLeadsCallsAdminDashboardDataError(error, action.api_type))
  }
}

function* onGetAdminDashboardDataLeads(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_dashboard/leads/${action.api_type.replace("leads_", '')}`,
      {
        body: JSON.stringify({
          ...action.payload.api_data,
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": user.token
        }
      })
    yield put(getLeadsAdminDashboardDataSuccess(response, action.api_type))
  } catch (error) {
    yield put(getLeadsAdminDashboardDataError(error, action.api_type))
  }
}


function* onGetAdminDashboardDataCalls(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const ver = action.api_ver
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/${ver}/admin_dashboard/calls/${action.api_type.replace("calls_", '')}`,
      {
        body: JSON.stringify({
          ...action.payload.api_data,
        }),
        headers: {
          "Content-Type": "application/json",
          "Authorization": user.token
        }
      })
    yield put(getCallsAdminDashboardDataSuccess(response, action.api_type))
  } catch (error) {
    yield put(getCallsAdminDashboardDataError(error, action.api_type))
  }
}

function* onGetAdminAnalyticsData(action) {
  const product_type = action?.product_type

  if (!product_type) {
    return;
  }

  const PRODUCT_TYPES = {
    CLICKS: 'clicks',
    SYNDI_CLICKS: 'syndi_clicks',
    QUOTE_FUNNELS: 'quote_funnels',
    CALLS: 'calls'
  };

  let ver;

  switch (product_type) {
    case PRODUCT_TYPES.CLICKS:
    case PRODUCT_TYPES.SYNDI_CLICKS:
    case PRODUCT_TYPES.QUOTE_FUNNELS:
    case PRODUCT_TYPES.CALLS:
      ver = action.api_ver;
      break;
    default:
      ver = 'v1';
  }

  try {
    const endpoint = `/api/${ver}/admin_analytics/${product_type}`
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )

    let total_response = []
    // TODO: uncomment if total footer is required in admin portal (this will make an extra API call)
    // if (!(action?.payload?.individual_clicks || action?.payload?.group_by_params?.length === 0)) {
    //   total_response = yield call(
    //     genericPostRequest,
    //     `${AppConfiguration.BACKEND_URL}${endpoint}`,
    //     {
    //       body: JSON.stringify({
    //         ...action.payload,
    //         group_by_params: []
    //       }),
    //       headers: {
    //         Authorization: user.token,
    //         'Content-Type': 'application/json'
    //       }
    //     }
    //   )
    // }

    // if (action?.payload?.group_by_params?.length === 0) {
    //   total_response = response;
    // }
    yield put(getAdminAnalyticsDataSuccess(response, total_response, product_type))
  } catch (error) {
    yield put(getAdminAnalyticsDataError(error, product_type))
  }
}

function* onGetAdminAnalyticsCompareToData(action) {
  const product_type = action?.product_type

  if (!product_type) {
    return;
  }

  const PRODUCT_TYPES = {
    CLICKS: 'clicks',
    SYNDI_CLICKS: 'syndi_clicks',
    QUOTE_FUNNELS: 'quote_funnels',
    CALLS: 'calls'
  };

  let ver;

  switch (product_type) {
    case PRODUCT_TYPES.CLICKS:
    case PRODUCT_TYPES.SYNDI_CLICKS:
    case PRODUCT_TYPES.QUOTE_FUNNELS:
    case PRODUCT_TYPES.CALLS:
      ver = action.api_ver;
      break;
    default:
      ver = 'v1';
  }

  try {
    const endpoint = `/api/${ver}/admin_analytics/${product_type}_compare_to`
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )

    let total_response = []
    // TODO: uncomment if total footer is required in admin portal (this will make an extra API call)
    // if (!(action?.payload?.individual_clicks || action?.payload?.group_by_params?.length === 0)) {
    //   total_response = yield call(
    //     genericPostRequest,
    //     `${AppConfiguration.BACKEND_URL}${endpoint}`,
    //     {
    //       body: JSON.stringify({
    //         ...action.payload,
    //         group_by_params: []
    //       }),
    //       headers: {
    //         Authorization: user.token,
    //         'Content-Type': 'application/json'
    //       }
    //     }
    //   )
    // }

    // if (action?.payload?.group_by_params?.length === 0) {
    //   total_response = response;
    // }
    yield put(getAdminAnalyticsCompareToDataSuccess(response, total_response, product_type))
  } catch (error) {
    yield put(getAdminAnalyticsCompareToDataError(error, product_type))
  }
}

//Admin Dashboard Revamped
function* onGetRevampedAdminAnalyticsData(action) {
  try {
    const endpoint = `/api/v3/admin_analytics/common`
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )

    let total_response = []
    yield put(getRevampedAdminAnalyticsDataSuccess(response, total_response))
  } catch (error) {
    yield put(getRevampedAdminAnalyticsDataError(error))
  }
}

function* onGetRevampedAdminAnalyticsCompareToData(action) {
  try {
    const endpoint = `/api/v3/admin_analytics/common_compare_to`
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )

    let total_response = []
    yield put(getRevampedAdminAnalyticsCompareToDataSuccess(response, total_response))
  } catch (error) {
    yield put(getRevampedAdminAnalyticsCompareToDataError(error))
  }
}

//Admin Dashboard Revamped

function* onGetAdminClickConvAggrAnalytics(action) {
  const product_type = action?.product_type || NAME_OF_PRODUCT_TYPES.CLICKS
  try {
    let user = bsh_getAdminUserDetails();
    const endpoint = `/api/v1/admin_pixel_agg_stats/${product_type}`
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )

    yield put(getAdminAnalyticsPixelStatsSuccess(response, product_type))
  } catch (error) {
    yield put(getAdminAnalyticsPixelStatsError(error, product_type))
  }
}

function* onGetAdminClickConvAggrCompareToAnalytics(action) {
  const product_type = action?.product_type || NAME_OF_PRODUCT_TYPES.CLICKS
  try {
    let user = bsh_getAdminUserDetails();
    const endpoint = `/api/v1/admin_pixel_agg_stats/${product_type}_compare_to`
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )

    yield put(getAdminAnalyticsPixelCompareToStatsSuccess(response, product_type))
  } catch (error) {
    yield put(getAdminAnalyticsPixelCompareToStatsError(error, product_type))
  }
}

function* onGetAdminUserSmartViews() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_smart_views`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getAdminUserSmartViewsSuccess(response))
  } catch (error) {
    yield put(getAdminUserSmartViewsError(error))
  }
}

function* onCreateAdminUserSmartViews(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_smart_views`,
      {
        body: JSON.stringify({
          ...action.payload.body
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(createAdminUserSmartViewsSuccess(response))
  } catch (error) {
    yield put(createAdminUserSmartViewsError(error))
  }
}

function* onUpdateAdminUserSmartViews(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_smart_views/${action.payload.ids.join(',')}`,
      {
        body: JSON.stringify({
          ...action.payload.body
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateAdminUserSmartViewsSuccess(response))
  } catch (error) {
    yield put(updateAdminUserSmartViewsError(error))
  }
}

function* onGetAdminDashboardRevampData(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v3/admin_dashboard/common/fetch_main_data`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }   
    )
    yield put(getAdminDashboardRevampDataSuccess(response?.main_data))
  } catch (error) {
    yield put(getAdminDashboardRevampDataError(error))
  }
}

function* onGetAdminDashboardDateRangeRevamp(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v3/admin_dashboard/common/fetch_date_ranges`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(getAdminDashboardDateRangeRevampSuccess(response?.date_ranges))
  } catch (error) {
    yield put(getAdminDashboardDateRangeRevampError(error))
  }
}

function* onGetAdminDashboardCompareToRevamp(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v3/admin_dashboard/common/fetch_compare_to_main_data`,
      {
        body: JSON.stringify({
          ...action.payload
        }), 
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(getAdminDashboardCompareToRevampSuccess(response?.compare_to_main_data))
  } catch (error) {
    yield put(getAdminDashboardCompareToRevampError(error))
  }
}





function* AdminDashboardSaga() {
  // yield takeEvery(GET_DASHBOARD_DATA, onGetDashboardData)
  yield takeEvery(LEADS_GET_ADMIN_DASHBOARD_DATA, onGetAdminDashboardDataLeads)
  yield takeEvery(GET_ADMIN_ANALYTICS_DATA, onGetAdminAnalyticsData)
  yield takeEvery(GET_ADMIN_ANALYTICS_COMPARE_TO_DATA, onGetAdminAnalyticsCompareToData)
  yield takeEvery(CALLS_GET_ADMIN_DASHBOARD_DATA, onGetAdminDashboardDataCalls)
  yield takeEvery(CLICKS_GET_ADMIN_DASHBOARD_DATA, onGetAdminDashboardDataClicks)
  yield takeEvery(SYNDI_CLICKS_GET_ADMIN_DASHBOARD_DATA, onGetAdminDashboardDataSyndiClicks)
  yield takeEvery(QUOTE_FUNNELS_GET_ADMIN_DASHBOARD_DATA, onGetAdminDashboardDataQuoteFunnels)
  yield takeEvery(QUOTE_FUNNELS_LEADS_CALLS_GET_ADMIN_DASHBOARD_DATA, onGetAdminDashboardDataQuoteFunnelsLeadsCalls)
  yield takeEvery(GET_ADMIN_ANALYTICS_PIXEL_STATS, onGetAdminClickConvAggrAnalytics)
  yield takeEvery(GET_ADMIN_ANALYTICS_PIXEL_COMPARE_TO_STATS, onGetAdminClickConvAggrCompareToAnalytics)
  yield takeEvery(GET_ADMIN_USER_SMART_VIEWS, onGetAdminUserSmartViews)
  yield takeEvery(CREATE_ADMIN_USER_SMART_VIEW, onCreateAdminUserSmartViews)
  yield takeEvery(UPDATE_ADMIN_USER_SMART_VIEW, onUpdateAdminUserSmartViews)

  yield takeEvery(GET_REVAMPED_ADMIN_ANALYTICS_DATA, onGetRevampedAdminAnalyticsData)
  yield takeEvery(GET_REVAMPED_ADMIN_ANALYTICS_COMPARE_TO_DATA, onGetRevampedAdminAnalyticsCompareToData)
  yield takeEvery(GET_ADMIN_DASHBOARD_REVAMP_DATA, onGetAdminDashboardRevampData)
  yield takeEvery(GET_ADMIN_DASHBOARD_DATE_RANGE_REVAMP, onGetAdminDashboardDateRangeRevamp)
  yield takeEvery(GET_ADMIN_DASHBOARD_COMPARE_TO_REVAMP, onGetAdminDashboardCompareToRevamp)
}

export default AdminDashboardSaga;
